import { TmcContextService } from './../../../../../../common/tmc-context.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { Station } from '../../../../../../client/model/station';
import { StationGroup } from '../../../../../../client/model/station-group';
import { StationSet } from '../../../../../../client/model/station-set';
import { StationSelection } from '../../../../../../common/model/station-selection.model';



@Component({
    selector: 'app-mobile-station-selection-menu',
    templateUrl: './station-selection-menu.component.html',
    styleUrls: ['./station-selection-menu.component.scss'],
    standalone: false
})
export class MobileStationSelectionMenuComponent {

  @Output() onCloseClick = new EventEmitter();

  @Output() onStationSelect = new EventEmitter<StationSelection>();

  stationGroups = new Array<StationGroup>();

  subscription: Subscription;

  constructor(
    private tmcContextService: TmcContextService,
    private route: ActivatedRoute,
    private router: Router
  ) {

    this.subscription = this.tmcContextService.updated.subscribe(
      yardConfiguration => {
        if (yardConfiguration != null) {
          this.stationGroups = yardConfiguration.stationGroups;
        }
      }
    );

  }

  clickClose() {
    this.onCloseClick.emit();
  }

  selectStation(stationSet: StationSet, station: Station) {
    this.onStationSelect.emit(new StationSelection({ station: station, stationSet: stationSet }));
    this.clickClose();
  }

  // /* evtl später relevant
  // onMenuEntryClick(menuEntry: MenuEntry) {
  //   this.updateURL(menuEntry.key, menuEntry.views[0].key);
  //   this.clickClose();
  // }
  // */

  // onSubMenuEntryClick(menuEntry: MenuEntry, view: View) {
  //   this.updateURL(menuEntry.key, view.key);
  //   this.clickClose();
  // }

  // updateURL(menuEntry: string, view: string) {

  //   console.log('creating url for', menuEntry, view);
  //   if (this.module != null) {
  //     const unitKey = this.route.snapshot.paramMap.get('unitKey');
  //     let urlPath = unitKey + '/' + this.module.key;
  //     if (menuEntry != null) {
  //       urlPath += '/' + menuEntry;
  //       if (view != null) {
  //         urlPath += '/' + view;
  //       }
  //     }

  //     console.log('next needed url is', urlPath);

  //     const url = this.router.createUrlTree(['/' + urlPath], { relativeTo: this.route }).toString();
  //     this.router.navigate([url]);
  //   }
  // }

}
